import type { DisciplineName } from '../api/types/instructor.types';

export const DISCIPLINE_DISPLAY_NAME_MAP: Record<DisciplineName, string> = {
  GroundSchool: 'Ground school',
  Simulator: 'Simulator training',
  SimCheck: 'Checking',
};

export function getDisciplineDisplayName(
  disciplineName: DisciplineName
): string {
  return DISCIPLINE_DISPLAY_NAME_MAP[disciplineName] ?? disciplineName;
}
